import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { View, Table, InfiniteScroll, ExternalLink, Icon } from '@components';
import { formatDateTimeS, formatDecimal, copyToClipboard } from '@utils';
import { getColorReference } from '../rules';
import { getProcessos } from '@ducks/logsTempos';

import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

const TableStyled = styled(Table)`
  .ant-table-row {
    cursor: pointer;
  }
`;

const ViewDuracao = styled(View)`
  padding: 0px 10px;
  border-radius: 10px;
  background-color: ${(props) => props.bgColor};
  color: #ffffff;
  font-weight: bold;
  margin: 0 10px;
`;

const ViewLegendas = styled(View)`
  padding: 10px;
  border: 1px solid #cccccc;
  width: fit-content;
  margin: 10px;
  border-radius: 10px;
`;

export default function ProcessosIndicadores() {
  const history = useHistory();
  const dispatch = useDispatch();

  const processos = useSelector(({ logsTempos }) => logsTempos.get('processos').toArray());
  const loadingProcessos = useSelector(({ logsTempos }) => logsTempos.get('loadingProcessos'));
  const hasMoreProcessos = useSelector(({ logsTempos }) => logsTempos.get('hasMoreProcessos'));
  const xCurrentPage = useSelector(({ logsTempos }) => logsTempos.get('xCurrentPage'));
  const idProcesso = useSelector(({ logsTempos }) => logsTempos.get('idProcesso'));

  const handleSearch = () => {
    dispatch(getProcessos({ id: idProcesso, page: xCurrentPage + 1 }));
  };

  useEffect(() => {
    handleSearch();
  }, []);

  const columns = [
    {
      title: 'Cliente',
      dataIndex: 'customer',
      key: 'customer',
      width: '175px',
    },
    {
      title: 'Usuário',
      dataIndex: 'userName',
      key: 'userName',
      width: '350px',
      render: (text, item) => <View>{text ? `${text} (${item.userId})` : `Sem nome (${item.userId})`}</View>,
    },
    {
      title: 'URL',
      dataIndex: 'url',
      key: 'url',
      width: '100%',
      render: (text) =>
        text === 'app' ? (
          <View>{text}</View>
        ) : (
          <View horizontal alignItems='center'>
            <ExternalLink
              style={{ whiteSpace: 'normal' }}
              onClick={(e) => {
                e.stopPropagation();
                window.location.href = text;
              }}
            >
              {text}
            </ExternalLink>
            &nbsp;
            <Icon.CopyOutlined
              onClick={(e) => {
                e.stopPropagation();
                copyToClipboard(text);
              }}
            />
          </View>
        ),
    },
    {
      title: 'Início',
      dataIndex: 'startDate',
      key: 'startDate',
      align: 'center',
      width: '175px',
      render: (text) => formatDateTimeS(text),
    },
    {
      title: 'Fim',
      dataIndex: 'endDate',
      key: 'endDate',
      align: 'center',
      width: '175px',
      render: (text) => formatDateTimeS(text),
    },
    {
      title: 'Duração (s)',
      dataIndex: 'duration',
      key: 'duration',
      align: 'center',
      width: '100px',
      render: (text) => (
        <View alignItems='center'>
          <ViewDuracao bgColor={getColorReference(text)}>{formatDecimal(text / 1000, { minDec: 3, maxDec: 3 })}</ViewDuracao>
        </View>
      ),
    },
  ];

  const handleSelection = (data) => {
    history.push(`/analise-desempenho/processos-web/processos/${data.contexto}/${data.lote}`);
  };

  const handleInfiniteOnLoad = () => {
    if (!hasMoreProcessos) {
      Notification.warning('Todos os logs foram retornados');
    } else {
      handleSearch();
    }
  };

  return (
    <View>
      <View alignItems='center'>
        <ViewLegendas horizontal>
          <ViewDuracao bgColor={getColorReference(999)}>&lt; 1s</ViewDuracao>
          <ViewDuracao bgColor={getColorReference(2499)}>&lt; 2.5s</ViewDuracao>
          <ViewDuracao bgColor={getColorReference(4999)}>&lt; 5s</ViewDuracao>
          <ViewDuracao bgColor={getColorReference(5000)}>&gt;= 5s</ViewDuracao>
        </ViewLegendas>
      </View>
      <View>
        <InfiniteScroll
          height={'550px'}
          dataLength={processos.length}
          next={handleInfiniteOnLoad}
          hasMore={!loadingProcessos && hasMoreProcessos}
        >
          <TableStyled
            rowKey='costumer'
            columns={columns}
            dataSource={processos}
            loading={loadingProcessos}
            hidePagination
            onRow={(data) => {
              return {
                onClick: () => {
                  handleSelection(data);
                },
              };
            }}
          />
        </InfiniteScroll>
      </View>
    </View>
  );
}
